import axios from 'axios';
import { ExtraParametersBatchModel } from '../Models/ExtraParametersBatchModel';

const updateExtraParametersBatch = (batch: ExtraParametersBatchModel) => axios.patch(`classifications/categories/${batch.categoriesId[0]}/extra-parameters/update-batch`, batch);

export default { 
    updateExtraParametersBatch
};